import { action, makeObservable, observable } from 'mobx';

/**
 * @name MyPopupStore
 */
class PopupStore {
  infoPopup = false;

  fairnessPop = false;

  checkHash = false;

  checkNextHash = false;

  winPopup = false;

  freeSpinState = false;

  _timer = null;

  connection = null;

  constructor() {
    makeObservable(this, {
      infoPopup: observable.deep,
      fairnessPop: observable.deep,
      checkHash: observable.deep,
      winPopup: observable.deep,
      freeSpinState: observable.deep,
      checkNextHash: observable.deep,
      connection: observable.struct,
      setInfoPopup: action.bound,
      setFairnessPop: action.bound,
      setCheckHash: action.bound,
      setWinPopup: action.bound,
      setFreeSpinState: action.bound,
      setConnectionState: action.bound,
      setCheckNextHash: action.bound,
    });
  }

  setInfoPopup(state) {
    this.infoPopup = state;
  }

  setFairnessPop(state) {
    this.fairnessPop = state;
  }

  setCheckHash(state) {
    this.checkHash = state;
  }

  setWinPopup(state) {
    this.winPopup = state;
    if (state) {
      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.winPopup = false;
      }, 3000);
    }
  }

  setFreeSpinState(state) {
    this.freeSpinState = state;
  }

  toggleInfoPopup() {
    this.setInfoPopup(!this.infoPopup);
  }

  toggleFairnessPop() {
    this.setFairnessPop(!this.fairnessPop);
  }

  toggleCheckHash() {
    this.setCheckHash(!this.checkHash);
  }

  setConnectionState(state) {
    this.connection = state;
  }

  setCheckNextHash(state) {
    this.checkNextHash = state;
  }

  toggleCheckNextHash() {
    this.setCheckNextHash(!this.checkNextHash);
  }
}

export const popupStore = new PopupStore();